import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
const forWho = ['Mujeres de 50 a 65+ que sufren de interrupciones de sueño por calor o ansiedad.', "Quienes despiertan cansadas a pesar de haber estado 'acostadas' 8 horas.", 'Mujeres que quieren dejar de depender de fármacos para poder descansar.', 'Madres y abuelas que necesitan recuperar su claridad mental y niveles de paciencia.'];
const notForWho = ["Personas que buscan una 'cura milagrosa' de una sola noche sin cambiar sus hábitos.", 'Hombres o jóvenes (este protocolo está calibrado para el sistema hormonal femenino 50+).'];
export function WhoIsFor() {
  return <section className="py-14 px-4 bg-navy-800/30" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-192">
          {/* For Who */}
          <FadeIn data-id="element-193">
            <div className="glass-card rounded-2xl p-6 md:p-8 h-full border-t-4 border-t-gold-400/50" data-id="element-194">
              <h3 className="text-xl font-heading font-bold text-gold-400 mb-5" data-id="element-195">
                Este protocolo ES para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-196">
                {forWho.map((text, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex items-start gap-4" data-id="element-197">
                    <CheckCircle className="w-6 h-6 text-gold-400 shrink-0 mt-0.5" strokeWidth={2} data-id="element-198" />
                    <span className="text-lg text-warmWhite-200" data-id="element-199">{text}</span>
                  </motion.li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For Who */}
          <FadeIn delay={0.2} data-id="element-200">
            <div className="glass-card rounded-2xl p-6 md:p-8 h-full border-t-4 border-t-red-400/30" data-id="element-201">
              <h3 className="text-xl font-heading font-bold text-warmWhite-100 mb-5 opacity-80" data-id="element-202">
                Este protocolo NO es para:
              </h3>
              <ul className="space-y-4" data-id="element-203">
                {notForWho.map((text, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex items-start gap-4 opacity-70" data-id="element-204">
                    <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-205" />
                    <span className="text-lg text-warmWhite-200" data-id="element-206">{text}</span>
                  </motion.li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}